import { TypographySmall } from '@talentmesh/ui/components/typography';

import { getSnapshotCounterString, getSnapshotDateString } from '../../Utils/ResultsUtils';

export interface SnapshotMetadataProps {
    current: number;
    total: number;
    date: Date;
}

function SnapshotMetadata({ current, total, date }: SnapshotMetadataProps) {
    return (
        <div className="flex flex-col gap-1">
            <p className="text-primary text-base">{getSnapshotCounterString(current, total)}</p>
            <TypographySmall className="text-muted-foreground">{getSnapshotDateString(date)}</TypographySmall>
        </div>
    );
}

export default SnapshotMetadata;
